var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bill-tracks-container grid-view",class:{
    'exceded': _vm.call.participants.length+1>50
  },attrs:{"tracks":_vm.call.participants.length+1}},[_c('Track',{staticClass:"bill-track-1",attrs:{"call":_vm.call}}),_vm._l((_vm.call.participants),function(participant,index){return _c('Track',{key:participant._id,class:`bill-track-${index+2}`,attrs:{"participant":participant,"call":_vm.call}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }